<script setup lang="ts">
import type { HTMLAttributes } from 'vue'

const props = withDefaults(
  defineProps<{
    class?: HTMLAttributes['class']
    icon?: string
    size?: string
    wrapperClass?: HTMLAttributes['class']
  }>(),
  {
    class: '',
    icon: undefined,
    size: '24px',
    wrapperClass: ''
  }
)
</script>
<template>
  <div
    v-if="icon"
    :class="
      cn(
        'p-2 bg-linear-to-t from-surface-container-low to-background shadow text-primary shrink-0 rounded-full overflow-hidden relative',
        wrapperClass
      )
    "
  >
    <Icon
      :class="cn('relative text-primary z-10', props.class)"
      :name="icon"
      :size="size"
    />
  </div>
</template>
